/*
 * @Descripttion: 客户订单号报备页
 * @Author: cb4786
 * @Date: 2023-08-28 17:38:13
 * @LastEditors: 黄佳鑫
 * @LastEditTime: 2026-02-27 13:24:16
 */

import { FC } from 'react'
import useHook from './hooks'
import styles from './style.module.scss'
import { Button, Form, Input, Modal, Space } from 'antd'
import CustomerUnitSelect from '../../components/CustomForm/CustomerUnitSelect'
import PlatformSelect from '../../components/PlatformSelect'
import { FilingNoDetailRes } from '../../api/Filing'
import { regexDict } from '../../tools/regex'
import Search from '../../components/SearchFilter'
import TableAntd from '../../components/TableAntd'
import ShowOnlyFormControl from '@/components/ShowOnlyFormControl'
const formLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 16 },
}
export interface Props {
  detail?: boolean
  id?: string
}

const AddReportReceipt: FC<Props> = (props: Props) => {
  const {
    isDetailPageMemo,
    form,
    state,
    isSubmitButtonLoading,
    isEditDisableMemo,
    handleClosePage,
    handleSubmit,
    handleFormDataChange,
    staffModalVisible,
    setStaffModalVisible,
    userListdataSource,
    handleSearchClick,
    onClickStaffRow,
    isH5Detail,
  } = useHook(props)
  const { formData, fillingSheetState, platformList } = state
  const userListColumns = [
    {
      key: 'name',
      title: '姓名',
    },
    {
      key: 'mobile',
      title: '手机号码',
    },
    {
      key: 'parentNames',
      title: '所属公司',
      render: (text: string) => (text ? text.split(',')[1] : ''),
    },
  ]
  return (
    <div className={styles['contianer']}>
      <div className={styles['order-info']}>
        <div className={styles['header']}>
          报备单信息
          {fillingSheetState.state === '审核驳回' && (
            <p className={styles['approvalOpinion']}>
              驳回原因：{fillingSheetState.approvalOpinion}
            </p>
          )}
        </div>
        <Form
          form={form}
          className={styles['content']}
          onValuesChange={handleFormDataChange}
          {...formLayout}
        >
          <Form.Item label="报备单号">
            <span>
              {isDetailPageMemo
                ? (formData as FilingNoDetailRes).filingNo
                : '保存后自动生成'}
            </span>
          </Form.Item>
          <Form.Item label="报备时间">
            <span>
              {isDetailPageMemo
                ? (formData as FilingNoDetailRes).filingTime
                : '保存后自动生成'}
            </span>
          </Form.Item>
          <Form.Item label="报备有效期">
            {isDetailPageMemo
              ? (formData as FilingNoDetailRes).validity
              : '保存后自动生成'}
          </Form.Item>
          {isDetailPageMemo ? (
            <Form.Item label="报备单状态">
              {isDetailPageMemo
                ? (formData as FilingNoDetailRes).state
                : '保存后自动生成'}
            </Form.Item>
          ) : null}

          {isH5Detail && (
            <Form.Item label="供应商" name={'supplierName'}>
              <ShowOnlyFormControl />
            </Form.Item>
          )}
          {isEditDisableMemo ? (
            <>
              <Form.Item noStyle name={'platform'}>
                <Input hidden />
              </Form.Item>
              <Form.Item label="下单平台" name={'platformName'} required>
                <Input disabled />
              </Form.Item>
            </>
          ) : (
            <Form.Item label="下单平台" name={'platform'} required>
              <PlatformSelect
                platformListData={platformList}
                placeholder="请输入"
                disabled={isEditDisableMemo}
                isH5Detail={isH5Detail}
              />
            </Form.Item>
          )}
          <Form.Item
            name={'orderNo'}
            label="客户订单号"
            required
            rules={[
              {
                required: true,
              },
              {
                ...regexDict.orderNoRegex,
              },
            ]}
          >
            <Input disabled={isEditDisableMemo} maxLength={100} />
          </Form.Item>
          <Form.Item
            name={'price'}
            label="报备金额"
            required
            rules={[
              {
                required: true,
              },
              {
                ...regexDict.filingPrice,
              },
            ]}
          >
            <Input disabled={isEditDisableMemo} />
          </Form.Item>
          <Form.Item name={'customerMdmCode'} hidden>
            <Input disabled></Input>
          </Form.Item>
          <Form.Item name={'crmExists'} hidden>
            <Input disabled></Input>
          </Form.Item>
          <Form.Item
            name={'dockingSalesName'}
            label="对接销售"
            required
            rules={[
              {
                required: true,
                message: '请选择对接销售',
              },
            ]}
          >
            <Input
              disabled={isEditDisableMemo}
              readOnly
              onClick={() => setStaffModalVisible(true)}
            />
          </Form.Item>
          {isH5Detail && (
            <Form.Item name={'approvalMan'} label="最终审核人">
              <Input disabled={true} />
            </Form.Item>
          )}
          <Form.Item label="对接销售id" name="dockingSalesId" noStyle>
            <Input hidden />
          </Form.Item>
          <Form.Item
            name={'customer'}
            label="客户单位"
            required
            rules={[
              {
                required: true,
              },
            ]}
            extra="请输入至少4个字进行搜索"
          >
            <CustomerUnitSelect
              disabled={isEditDisableMemo}
              onChange={(v, option) =>
                form.setFieldsValue({
                  customerMdmCode: (option as any)?.key || undefined,
                  crmExists: (option as any)?.crmExists,
                })
              }
              style={{ width: '400px' }}
            />
            {/* <Input disabled={isEditDisableMemo} maxLength={100} /> */}
          </Form.Item>
          <Form.Item name={'remark'} label="备注" className="remarkFormitem">
            <Input.TextArea disabled={isEditDisableMemo} maxLength={500} />
          </Form.Item>
        </Form>
      </div>
      {!isEditDisableMemo ? (
        <div className={styles['bottom-buttons-container']}>
          <Space>
            <div>
              <Button onClick={handleClosePage}>取消</Button>
            </div>
            <Button
              type="primary"
              onClick={handleSubmit}
              className={styles['button-item']}
              loading={isSubmitButtonLoading}
            >
              提交
            </Button>
          </Space>
        </div>
      ) : null}
      <Modal
        title="请选择员工"
        destroyOnClose
        width={900}
        style={{ top: '25%' }}
        open={staffModalVisible}
        footer={null}
        maskClosable={false}
        onCancel={() => setStaffModalVisible(false)}
      >
        <Search
          hideScheme
          keyName="RELEVANCEBUYER"
          ScreenKey="RELEVANCEBUYER"
          fieldsData={['realName', 'mobile']}
          onSearch={handleSearchClick}
        />
        <TableAntd
          selfAdaptScroll
          loading={userListdataSource.loading}
          dataSource={userListdataSource.data}
          listColumn={userListColumns}
          onRow={(record: any) => {
            return {
              onClick: () => onClickStaffRow(record), // 点击行
            }
          }}
        />
      </Modal>
    </div>
  )
}

export default AddReportReceipt
/*
 * @Descripttion: 客户订单号报备页
 * @Author: cb4786
 * @Date: 2023-08-28 17:38:13
 * @LastEditors: 黄佳鑫
 * @LastEditTime: 2026-02-27 13:24:16
 */

import { FC } from 'react'
import useHook from './hooks'
import styles from './style.module.scss'
import { Button, Form, Input, Modal, Space } from 'antd'
import CustomerUnitSelect from '../../components/CustomForm/CustomerUnitSelect'
import PlatformSelect from '../../components/PlatformSelect'
import { FilingNoDetailRes } from '../../api/Filing'
import { regexDict } from '../../tools/regex'
import Search from '../../components/SearchFilter'
import TableAntd from '../../components/TableAntd'
import ShowOnlyFormControl from '@/components/ShowOnlyFormControl'
const formLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 16 },
}
export interface Props {
  detail?: boolean
  id?: string
}

const AddReportReceipt: FC<Props> = (props: Props) => {
  const {
    isDetailPageMemo,
    form,
    state,
    isSubmitButtonLoading,
    isEditDisableMemo,
    handleClosePage,
    handleSubmit,
    handleFormDataChange,
    staffModalVisible,
    setStaffModalVisible,
    userListdataSource,
    handleSearchClick,
    onClickStaffRow,
    isH5Detail,
  } = useHook(props)
  const { formData, fillingSheetState, platformList } = state
  const userListColumns = [
    {
      key: 'name',
      title: '姓名',
    },
    {
      key: 'mobile',
      title: '手机号码',
    },
    {
      key: 'parentNames',
      title: '所属公司',
      render: (text: string) => (text ? text.split(',')[1] : ''),
    },
  ]
  return (
    <div className={styles['contianer']}>
      <div className={styles['order-info']}>
        <div className={styles['header']}>
          报备单信息
          {fillingSheetState.state === '审核驳回' && (
            <p className={styles['approvalOpinion']}>
              驳回原因：{fillingSheetState.approvalOpinion}
            </p>
          )}
        </div>
        <Form
          form={form}
          className={styles['content']}
          onValuesChange={handleFormDataChange}
          {...formLayout}
        >
          <Form.Item label="报备单号">
            <span>
              {isDetailPageMemo
                ? (formData as FilingNoDetailRes).filingNo
                : '保存后自动生成'}
            </span>
          </Form.Item>
          <Form.Item label="报备时间">
            <span>
              {isDetailPageMemo
                ? (formData as FilingNoDetailRes).filingTime
                : '保存后自动生成'}
            </span>
          </Form.Item>
          <Form.Item label="报备有效期">
            {isDetailPageMemo
              ? (formData as FilingNoDetailRes).validity
              : '保存后自动生成'}
          </Form.Item>
          {isDetailPageMemo ? (
            <Form.Item label="报备单状态">
              {isDetailPageMemo
                ? (formData as FilingNoDetailRes).state
                : '保存后自动生成'}
            </Form.Item>
          ) : null}

          {isH5Detail && (
            <Form.Item label="供应商" name={'supplierName'}>
              <ShowOnlyFormControl />
            </Form.Item>
          )}
          {isEditDisableMemo ? (
            <>
              <Form.Item noStyle name={'platform'}>
                <Input hidden />
              </Form.Item>
              <Form.Item label="下单平台" name={'platformName'} required>
                <Input disabled />
              </Form.Item>
            </>
          ) : (
            <Form.Item label="下单平台" name={'platform'} required>
              <PlatformSelect
                platformListData={platformList}
                placeholder="请输入"
                disabled={isEditDisableMemo}
                isH5Detail={isH5Detail}
              />
            </Form.Item>
          )}
          <Form.Item
            name={'orderNo'}
            label="客户订单号"
            required
            rules={[
              {
                required: true,
              },
              {
                ...regexDict.orderNoRegex,
              },
            ]}
          >
            <Input disabled={isEditDisableMemo} maxLength={100} />
          </Form.Item>
          <Form.Item
            name={'price'}
            label="报备金额"
            required
            rules={[
              {
                required: true,
              },
              {
                ...regexDict.filingPrice,
              },
            ]}
          >
            <Input disabled={isEditDisableMemo} />
          </Form.Item>
          <Form.Item name={'customerMdmCode'} hidden>
            <Input disabled></Input>
          </Form.Item>
          <Form.Item name={'crmExists'} hidden>
            <Input disabled></Input>
          </Form.Item>
          <Form.Item
            name={'dockingSalesName'}
            label="对接销售"
            required
            rules={[
              {
                required: true,
                message: '请选择对接销售',
              },
            ]}
          >
            <Input
              disabled={isEditDisableMemo}
              readOnly
              onClick={() => setStaffModalVisible(true)}
            />
          </Form.Item>
          {isH5Detail && (
            <Form.Item name={'approvalMan'} label="最终审核人">
              <Input disabled={true} />
            </Form.Item>
          )}
          <Form.Item label="对接销售id" name="dockingSalesId" noStyle>
            <Input hidden />
          </Form.Item>
          <Form.Item
            name={'customer'}
            label="客户单位"
            required
            rules={[
              {
                required: true,
              },
            ]}
            extra="请输入至少4个字进行搜索"
          >
            <CustomerUnitSelect
              disabled={isEditDisableMemo}
              onChange={(v, option) =>
                form.setFieldsValue({
                  customerMdmCode: (option as any)?.key || undefined,
                  crmExists: (option as any)?.crmExists,
                })
              }
              style={{ width: '400px' }}
            />
            {/* <Input disabled={isEditDisableMemo} maxLength={100} /> */}
          </Form.Item>
          <Form.Item name={'remark'} label="备注" className="remarkFormitem">
            <Input.TextArea disabled={isEditDisableMemo} maxLength={500} />
          </Form.Item>
        </Form>
      </div>
      {!isEditDisableMemo ? (
        <div className={styles['bottom-buttons-container']}>
          <Space>
            <div>
              <Button onClick={handleClosePage}>取消</Button>
            </div>
            <Button
              type="primary"
              onClick={handleSubmit}
              className={styles['button-item']}
              loading={isSubmitButtonLoading}
            >
              提交
            </Button>
          </Space>
        </div>
      ) : null}
      <Modal
        title="请选择员工"
        destroyOnClose
        width={900}
        style={{ top: '25%' }}
        open={staffModalVisible}
        footer={null}
        maskClosable={false}
        onCancel={() => setStaffModalVisible(false)}
      >
        <Search
          hideScheme
          keyName="RELEVANCEBUYER"
          ScreenKey="RELEVANCEBUYER"
          fieldsData={['realName', 'mobile']}
          onSearch={handleSearchClick}
        />
        <TableAntd
          selfAdaptScroll
          loading={userListdataSource.loading}
          dataSource={userListdataSource.data}
          listColumn={userListColumns}
          onRow={(record: any) => {
            return {
              onClick: () => onClickStaffRow(record), // 点击行
            }
          }}
        />
      </Modal>
    </div>
  )
}

export default AddReportReceipt
